import ApiService from "../../../ceres/services/ApiService";

const state = () => ({
	eventQueue: []
});

const mutations = {
	logMetrics(__, variationID) {
		if (App.config.log.performanceLevel === "development") {
			/* eslint-disable no-console */
			console.log({
				variationID
			});
			/* eslint-enable no-console */
		}
	},
	addEvent(state, event) {
		state.eventQueue.push(event);
	},
	removeEvent(state, index) {
		state.eventQueue.splice(index, 1);
	}
};

const actions = {
	sendMetrics(__, variationID) {
		ApiService.get("/rest/erosbackend/session/add", {
			variationID
		});
	},

	trackEvent({ commit, dispatch }, payload) {
		commit("addEvent", payload);
		dispatch("runQueue");
	},

	runQueue({ state, dispatch }) {
		if (state.eventQueue.length > 0) {
			const eventQueue = state.eventQueue;

			eventQueue.forEach((event, index) => {
				dispatch("runEvent", { event, index });
			});
		}
	},

	/*
	 * event model:
	 * {
	 * 	provider: <String>,
	 * 	event: {
	 * 		<EventProviderDataModel>
	 * 	}
	 * }
	 */
	runEvent({ commit, getters }, payload) {
		const payloadEvent = payload.event;
		const event = payloadEvent.event;
		const provider = payloadEvent.provider;
		const eventKeys = Object.keys(event);

		if (
			["gtag", "fbq", "pinterest"].includes(provider) &&
			eventKeys.includes("command") &&
			eventKeys.includes("scope") &&
			eventKeys.includes("payload")
		) {
			if (provider === "gtag" && getters.isConsented("marketing.googleTagManager") && !!window.gtag) {
				gtag(event.command, event.scope, event.payload);
				commit("removeEvent", payload.index);
			} else if (provider === "fbq" && getters.isConsented("marketing.facebookPixel") && !!window.fbq) {
				fbq(event.command, event.scope, event.payload);
				commit("removeEvent", payload.index);
			} else if (provider === "pinterest" && getters.isConsented("marketing.pinterestTracking") && !!window.pintrk) {
				pintrk(event.command, event.scope, event.payload);
				commit("removeEvent", payload.index);
			}
		}
	}
};

export default {
	actions,
	state,
	mutations
};
